<h3 [innerHTML]="this.data.window_title | safeHtml"></h3>
<div class="data-search-window">
  <div>
    <div class="top-row-controls-container">
      <div [hidden]="data.hide_search">
        <scaffold-search-bar
          [allowSearch]="true"
          (search)="search($event)"
          [searchData]="data.listSearchOptions || []"
          [(perPage)]="perPage"></scaffold-search-bar>
      </div>

      <scaffold-paginate-page-select
        (perPageChange)="perPageChange($event)"
        [(perPage)]="perPage"
        [countLabel]="getCountLabel()"></scaffold-paginate-page-select>
    </div>
  </div>
  <div
    *ngIf="results"
    class="data-search-results scaffold-list-holder"
    [ngClass]="{ 'horizontal-list': data.horizontal_list }">
    <ng-container *ngIf="headers">
      <header
        style="
          display: flex;
          margin: 16px 0px;
          font-weight: bold;
          border-bottom: 1px solid #ddd;
          padding-bottom: 8px;
        ">
        <div
          class="flex-column-0"
          style="
            padding: 0 5px;
            display: flex;
            justify-content: center;
            align-items: center;
          "
          *ngIf="!data.horizontal_list && data.allow_multiple">
          <p-checkbox
            [style.visibility]="'hidden'"
            binary="true"
            status="info"
            style="pointer-events: auto"></p-checkbox>
        </div>
        <label
          *ngFor="let header of headers"
          [class]="header.header_width || 'flex-column-1'">
          {{ header?.header_text }}
        </label>
      </header>
    </ng-container>
    <!-- <scaffold-paginator
      *ngIf="!data.hide_search"
      [itemCount]="listTotalNumberOfItems"
      [(activePage)]="active"
      [perPage]="perPage"
    ></scaffold-paginator> -->
    <div
      class="scaffold-list-item"
      *ngFor="let ite of results; let $i = index"
      [ngClass]="{
        'scaffold-item-selected': ite === selected,
        'scaffold-item-disabled': isLinked(ite.id) && !data.allow_multiple,
      }">
      <div (click)="setSelected(ite, $i)" class="flex-row flex-vertical-center">
        <div
          class="flex-column-0"
          style="padding: 0 5px"
          *ngIf="!data.horizontal_list && data.allow_multiple">
          <p-checkbox
            binary="true"
            status="info"
            [(ngModel)]="data_check[ite.id].linked"
            style="pointer-events: none"></p-checkbox>
        </div>
        <div class="flex-column-1">
          <app-view
            [items]="ite.data.content"
            [info]="ite"
            [data]="{}"></app-view>
          <div
            style="text-align: center; display: block; margin-bottom: 5px"
            *ngIf="data.horizontal_list">
            <p-checkbox
              binary="true"
              status="info"
              [(ngModel)]="data_check[ite.id].linked"
              style="pointer-events: none"
              *ngIf="data.allow_multiple">
            </p-checkbox>
          </div>
        </div>
      </div>
      <hr *ngIf="!data.horizontal_list" />
    </div>
    <scaffold-paginator
      *ngIf="!data.hide_search"
      [itemCount]="listTotalNumberOfItems"
      [(activePage)]="active"
      [perPage]="perPage"></scaffold-paginator>
  </div>
</div>
